import type { RouteRecordRaw } from "vue-router";
import type { MjfRouteMeta } from "@shared/types/localTypes/router";
import { RouteNames } from "@shared/types/localTypes/router";
import { idpLogin } from "@/router/guard/idp-login.ts";

// Deliberately a top-level record and not a child of "/auth": vue-router merges parent meta,
// and "/auth" is marked isGuest, which bounces users who still have a stale session marker
// before the guard can restart the IdP login.
export default {
  path: "/idp-login",
  name: RouteNames.IdpLogin,
  component: () => import("@/views/login/LoginBase.vue"),
  meta: { hideLayout: true } as MjfRouteMeta,
  beforeEnter: idpLogin,
} as RouteRecordRaw;
